import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewSector = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'sector',
        name: 'Sector',
        component: ViewSector,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
